import { render } from "./FormTextarea.vue?vue&type=template&id=54252c2b"
import script from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/FormTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54252c2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54252c2b', __exports__)) {
    api.reload('54252c2b', __exports__)
  }
  
  module.hot.accept("./FormTextarea.vue?vue&type=template&id=54252c2b", () => {
    api.rerender('54252c2b', render)
  })

}


export default __exports__